import React from 'react';
import ReportTemplateClientCSVClick from '../ReportTemplateClientCSVClick';
import { formatDate } from '../../Utilities/GridTools';

const CanClosed30Days = () => {
    const columnDefs = [
        { headerName: 'Debtor ID', field: 'debtorid' },
        { headerName: 'Adjuster', field: 'insuranceAdjuster' },
        { headerName: 'Ref',field:'clientRefNo'},
        { headerName: 'Debtor Status', field: 'debtorStatus' },
        { headerName: 'List Date', field: 'listDate',valueFormatter: formatDate, filter: 'agDateColumnFilter' },
        { headerName: 'Status Date', field: 'accountStatusDate', valueFormatter: formatDate,filter: 'agDateColumnFilter' },
        { headerName: 'Project', field: 'projectID' }   
    ];

    const apiUrl = `${process.env.REACT_APP_API_URL}/Reports/Executive/CanClosed30Days`;

    return (
        <ReportTemplateClientCSVClick columnDefs={columnDefs} apiUrl={apiUrl} reportName={'CAN Closed 30 Days'} />
    );
};  


export default CanClosed30Days;